/*
 * Copyright (c) 2026 Bluemate B.V.
 */

import React, {useEffect, useState} from 'react';

import {useTranslation} from 'react-i18next';

import {useOnlineStatus} from '../../util/pwaUtil';

import {onShowConfirmSnackbar} from '../../util/renderUtil';

import BluemateDialog from '../controls/dialog/bluemateDialog';

export default function OfflineOverlay() {
    const online = useOnlineStatus();
    const {t} = useTranslation();
    const [dismissed, setDismissed] = useState(false);

    useEffect(() => {
        if (online) setDismissed(false);
    }, [online]);

    function onRetry() {
        if (navigator.onLine) {
            onShowConfirmSnackbar(t('pwa.offlineReconnected', 'Verbinding hersteld'));
            window.location.reload();
            return;
        }
        onShowConfirmSnackbar(t('pwa.offlineStillNoConnection', 'Nog steeds geen verbinding'), {
            backgroundColor: 'color-blue-bluemate',
            textColor: 'white'
        });
    }

    return (
        <BluemateDialog
            active={!online && !dismissed}
            onClose={() => setDismissed(true)}
            title={t('pwa.offlineTitle', 'Geen verbinding')}
            onConfirm={onRetry}
            confirmLabel={t('pwa.offlineRetry', 'Opnieuw proberen')}
            cancelLabel={t('pwa.offlineDismiss', 'Toch doorgaan')}
        >
            <p>{t('pwa.offlineMessage', 'Controleer je internetverbinding en probeer het opnieuw.')}</p>
        </BluemateDialog>
    );
}
